import ReactTooltip from 'react-tooltip'
import { SimutechBlue } from '../styles/Theme'
import './Tooltip.scss'

// Usage: https://github.com/wwayne/react-tooltip#readme

export const Tooltip = () => <ReactTooltip type={'light'} effect={'solid'} delayShow={300} backgroundColor={'white'} textColor={SimutechBlue} className={'scoreboardTooltip'} />
